import axios from '@axios'

const PREFIX = '/propostas'

export default {
  source: null,
  CancelToken: null,

  adicionarProposta(proposta) {
    return axios.post(`${PREFIX}/proposta`, proposta)
  },

  atualizarProposta(id, proposta) {
    return axios.put(`${PREFIX}/${id}`, proposta)
  },

  atualizarPropostaCheckList(proposta, geracheckList) {
    return axios.put(`${PREFIX}/check-list?geraProposta=${geracheckList}`, proposta)
  },

  atualizarStatusFaturamentoServico(servicoId, servico) {
    return axios.put(`${PREFIX}/update-servico/${servicoId}`, servico)
  },

  getProposta(id) {
    return axios.get(`${PREFIX}/${id}`)
  },

  addComentarioProposta(id, tramiteObservacao, observacaoInterna) {
    return axios.post(`${PREFIX}/comentario?propostaId=${id}&observacao=${observacaoInterna}`, { comentario: tramiteObservacao })
  },

  updateComentarioProposta(id, tramiteObservacao) {
    return axios.put(`${PREFIX}/comentario/${id}`, tramiteObservacao)
  },

  deleteComentarioProposta(id) {
    return axios.delete(`${PREFIX}/comentario/${id}`)
  },

  getPropostasResumidas(filtros, externo) {
    if (externo) {
      return axios.post(`${PREFIX}/portal-proposta/proposta-resumidas`, filtros)
    }
    return axios.post(`${PREFIX}/proposta-resumidas`, filtros)
  },

  enviarProposta(proposta, tipoEmail) {
    return axios.post(`${PREFIX}/envio-notificacao?tipoEmail=${tipoEmail}`, proposta)
  },

  copiarProposta(proposta) {
    return axios.post(`${PREFIX}/copia-proposta`, proposta)
  },

  excluirProposta(propostaId) {
    return axios.delete(`${PREFIX}/${propostaId}`)
  },

  getHistoricosProposta(propostaId) {
    return axios.get(`${PREFIX}/historico/${propostaId}`)
  },

  getHistoricoVisualizacaoProposta(propostaId) {
    return axios.get(`${PREFIX}/visualizacao/${propostaId}`)
  },

  alterarStatusProposta(form) {
    return axios.post(`${PREFIX}/alterar-status`, form)
  },

  getAnexoUrl(anexoId) {
    return axios.get(`${PREFIX}/url-anexo?anexoId=${anexoId}`)
  },

  getRelatorioProposta(id, token = null) {
    const params = token ? { token } : {}
    return axios.get(`${PREFIX}/relatorio-proposta/${id}`, { params, responseType: 'arraybuffer' })
  },

  getRelatorioChecklist(id) {
    return axios.get(`${PREFIX}/relatorio-checklist/${id}`)
  },

  adicionarPropostaChecklist(gerarProposta, proposta) {
    return axios.post(`${PREFIX}/proposta-checklist?gerar=${gerarProposta}`, proposta)
  },

  addAnexoItemCheckList(itemCheckList, tokenCancel, externo) {
    this.source = tokenCancel.source()
    this.CancelToken = tokenCancel

    if (externo) {
      return axios.post(`${PREFIX}/portal-proposta/anexo-check-list-insert`, itemCheckList, { cancelToken: this.source.token })
    }
    return axios.post(`${PREFIX}/anexo-check-list-insert`, itemCheckList, { cancelToken: this.source.token })
  },

  getURLItemCheckList(itemId, externo) {
    if (externo) {
      return axios.get(`${PREFIX}/portal-proposta/anexo-check-list?itemId=${itemId}`)
    }
    return axios.get(`${PREFIX}/anexo-check-list?itemId=${itemId}`)
  },

  deleteAnexoItemCheckList(itemId, externo) {
    if (externo) {
      return axios.delete(`${PREFIX}/portal-proposta/delete-anexo-item?itemId=${itemId}`)
    }
    return axios.delete(`${PREFIX}/delete-anexo-item?itemId=${itemId}`)
  },

  abortarUpload() {
    this.source.cancel()
  },

  getPreGeracaoContrato(id) {
    return axios.get(`${PREFIX}/pre-contrato/${id}`)
  },

  substituirTagsContrato(contrato, id = 0, salvar = false) {
    return axios.post(`${PREFIX}/pre-contrato/substituir-tags?id=${id}&salva=${salvar}`, contrato)
  },

  salvarAlteracaoContrato(contrato, id) {
    return axios.put(`${PREFIX}/contrato/${id}`, contrato)
  },

  getPropostasParaAgrupamento(id) {
    return axios.get(`${PREFIX}/${id}/agrupado`)
  },

  notificarPropostasAgrupadas(propostas) {
    return axios.post(`${PREFIX}/notificacao/agrupado`, propostas)
  },

  adicionarPropostaEmpresas(id, empresas) {
    return axios.post(`${PREFIX}/${id}/empresa-proposta`, empresas)
  },

  notificarPropostaAguardandoEnvioDados(proposta) {
    return axios.post(`${PREFIX}/notificacao/aguardando-envio-dados`, proposta)
  },

  atualizaPropostaContratante(dadoContratante) {
    return axios.put(`${PREFIX}/proposta-contratante`, dadoContratante)
  },

  adicionarPropostaContratante(id, dadoContratante) {
    return axios.post(`${PREFIX}/${id}/add-proposta-contratante`, dadoContratante)
  },

  buscaPropostaContratante(propostaContratante) {
    return axios.post(`${PREFIX}/proposta-contratante`, propostaContratante)
  },

  integrarEmpresasManualmenteOmie(id, empresas) {
    return axios.post(`${PREFIX}/${id}/integra-empresa-omie`, empresas)
  },
  integrarEmpresasManualmenteGClick(propostaId) {
    return axios.post(`${PREFIX}/integrar-proposta-manual-gclick/${propostaId}`)
  },

  buscaCadastrosGClickByPropostaId(propostaId) {
    return axios.get(`${PREFIX}/buscar-cadastros-gclick/${propostaId}`)
  },
  buscarRazaoSocialCnpj(cnpj, externo) {
    const decodificado = cnpj.replace('/', '%2F')
    if (externo) {
      return axios.get(`${PREFIX}/portal-proposta/busca-dados-cnpjs?cnpj=${decodificado}`)
    }
    return axios.get(`${PREFIX}/busca-dados-cnpjs?cnpj=${decodificado}`)
  },

  alterarStatusSucessoManualmente(id) {
    return axios.put(`${PREFIX}/sucesso-contrato-omie/${id}`)
  },

  salvarRateioValoresEmpresa(id, rateio, atualizar) {
    return axios.post(`${PREFIX}/${id}/rateio-empresa?atualizar=${atualizar}`, rateio)
  },

  getRateioProposta(id) {
    return axios.get(`${PREFIX}/${id}/rateio-empresa`)
  },
  aprovarContratoPropostaManualmenteSemUpload(propostaId) {
    return axios.post(`${PREFIX}/upload-contrato-manualmente/${propostaId}`)
  },
  aprovarContratoPropostaManualmente(propostaId, arquivo) {
    const formData = new FormData()
    formData.append('arquivo', arquivo)
    return axios.post(`${PREFIX}/upload-contrato-manualmente/${propostaId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  getDocumentosProposta(propostaId) {
    return axios.get(`${PREFIX}/documentos/${propostaId}`)
  },
  deletaDocumentoProposta(propostaId, documentoId) {
    return axios.delete(`${PREFIX}/documentos/${propostaId}/${documentoId}`)
  },
  salvarDocumentosProposta(propostaId, documentos) {
    return axios.post(`${PREFIX}/documentos/${propostaId}`, documentos)
  },
  atualizaDocumentoCobrancaStatus(id, status, justificativa) {
    return axios.post(`${PREFIX}/documentos/${id}/alterar-status?status=${status}&justificativa=${justificativa}`)
  },
  getArquivoDocumento(documentoId) {
    return axios.get(`${PREFIX}/documentos/${documentoId}/view`)
  },
  cobrarDocumentosProposta(propostaId) {
    return axios.post(`${PREFIX}/documentos/cobrar-documentos-proposta/${propostaId}`)
  },
  getDocumentosAssinaturaProposta(propostaId) {
    return axios.get(`${PREFIX}/documentos-assinatura-proposta/${propostaId}`)
  },
  enviarContratoAtualizado(id) {
    return axios.post(`${PREFIX}/processa-fluxo-assinatura/${id}`)
  },
}
